
import { Options, Vue } from 'vue-class-component';

import { service } from '@/service';
import { delibird } from '@/service/delibird';
import { preferences } from '@/service/preferences';

import MaterialButton from '@/components/material/Button.vue';
import MaterialSwitch from '@/components/material/Switch.vue';
import PreferenceRow from './Row.vue';

import locales from './Google.locales.json';

@Options({
    components: {
        MaterialButton, MaterialSwitch,
        PreferenceRow
    },
    i18n: {
        messages: locales
    }
})
export default class GooglePreferences extends Vue {

    get loaded() {
        return this.$store.state.google.loaded;
    }

    get authed() {
        return this.$store.state.google.authed;
    }

    get idle() {
        return this.$store.state.service.status === service.Status.idle;
    }

    get sync(): boolean {
        return preferences.google.sync();
    }

    set sync(value: boolean) {
        preferences.google.setSync(value);
    }

    link() {
        service.signIn();
    }

    unlink() {
        service.signOut();
    }

    doSync() {
        service.sync();
    }

    upload() {
        service.upload();
    }

    migrate() {
        service.migrate((count) => {
            delibird.inform(`Migrated ${count} nominations.`);
        });
    }
}
